import { useState } from 'react';
import { useEventListener } from './useEventListener';

const readWindowSize = () => ({ width: window.innerWidth, height: window.innerHeight });

export function useWindowSize(): { width: number; height: number } {
  const [size, setSize] = useState(readWindowSize);
  useEventListener('resize', () => setSize(readWindowSize()));
  return size;
}
